export { default as progressTemplate } from './progress.dot';
export {
  default as progressTimeIndicatorTemplate,
} from './progressTimeIndicator.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/controls/progress/templates/index.ts